import { defineStore } from 'pinia';
import getters from './getters';
import actions from './actions';
function initState() {
    return {
        customizedCity: [],
        searchCharts: [], // suggestion The sorting display rules for 
        isExactSearch: false,
        propertyConfigs: [],
        keywordType: '',
        keyword: '',
        searchData: [], //  Middle platform 
        // showLocation: false, //  Middle platform 
        locationSuggestionUrl: '', //  Middle platform ,
        locationPlaceholder: ''
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    getters,
    actions
});
